export const getUserSearchResult = state => {
    const { result } = state.userSearch;
    if (!result) {
        return undefined;
    }

    // filter only users that are not already members of the organization
    return result;
};

export const isAddMember = state => state.userSearch.isAddMember;



// WEBPACK FOOTER //
// ./src/selectors/userSearchSelectors.js